'use client'

import { HomeSearchContext, useHomeSearchState } from '@homeSearch/modules/context'
import { fetchEstimate } from '@homeSearch/modules/fetch'
import HomeSearchInput from '@homeSearch/modules/input'
import Location from '@homeSearch/modules/location'
import HomeSearchPopup from '@homeSearch/modules/popup'
import useProgressRouter from '@hooks/useProgressRouter'
import { mapDataLayer } from '@plugin/google/gtm/modules/estimate'
import getEstimateRoute from '@plugin/searchRoute/modules/estimate'
import { estimateMap } from '@router'
import { get, replace, size } from 'lodash-es'
import { Suspense, useCallback, useEffect, useRef } from 'react'
import { useMount } from 'react-use'

const ESTIMATE_MAP_SUBURBS_KEY = 'or-estimate-map-suburbs'
export default function EstimateMapSearch({
  state,
  suburbs,
  streetLabel
}) {

  const searchState = useHomeSearchState({
    oneSuburb: false,
    recentSuburb: false
  })
  const { setSuburbs } = searchState

  useEffect(() => {
    // 尝试读取本地是否有缓存的suburbs
    const localSuburbs = get(JSON.parse(localStorage.getItem(ESTIMATE_MAP_SUBURBS_KEY)), slugToLocalKey(state.slug))
    setSuburbs(localSuburbs || suburbs)
  }, [suburbs, state, setSuburbs])

  // 选择城区
  const { replaceRouter } = useProgressRouter()
  const searchHandle = useCallback(({ suburbs }) => {
    if (!size(suburbs)) return
    const { slug } = state

    const estimateRoute = getEstimateRoute()
    estimateRoute.fromSlug(slug)
    estimateRoute.clearSuburbs()
    estimateRoute.setSuburbs(suburbs)
    const newSlug = estimateRoute.toSlug()

    if (!estimateRoute.isEqualSlug(slug)) {
      // 缓存当前slug对应的suburbs
      localStorage.setItem(ESTIMATE_MAP_SUBURBS_KEY, JSON.stringify({ [slugToLocalKey(newSlug)]: suburbs }))
      mapDataLayer.selectDropdown()
      replaceRouter(estimateMap(newSlug))
    }
  }, [state, replaceRouter])

  const boxRef = useRef(null)
  useMount(() => {
    setTimeout(() => {
      if (boxRef.current && streetLabel) {
        const input = boxRef.current.querySelector('input')
        input && (input.value = streetLabel)
      }
    }, 200)
  })
  return (
    <HomeSearchContext.Provider value={searchState}>
      <div className='p-10 sm:px-16' ref={boxRef}>
        <Suspense>
          <HomeSearchInput showSearchButton={false} onSearch={searchHandle}>
            <HomeSearchPopup showSurround={false} fetcher={fetchEstimate}></HomeSearchPopup>
          </HomeSearchInput>
        </Suspense>
        <Location></Location>
      </div>
    </HomeSearchContext.Provider>
  )
}

function slugToLocalKey(slug) {
  return replace(slug, /[^a-z0-9-]+/g, '')
}
